import { BaseElement3d, BaseElement3dOptions } from "./BaseElement3d.js";

export interface Rings3dOptions extends BaseElement3dOptions {
    radius: number;
    gap?: number;
    count?: number;
}

export class Rings3d extends BaseElement3d {

    private _rings: THREE.Line[] = [];
    private _gap: number;

    private static _geometry: THREE.BufferGeometry = null;

    constructor(options: Rings3dOptions) {

        super();

        options = e5.object.merge({
            gap: 80,
            count: 5,
            opacity: 0.08
        } as Rings3dOptions, options);

        this.create(options);

        this._gap = options.gap;

        var count = options.count + 1;
        for (var i = 1; i < count; ++i) {
            var ratio = 1 - (i / count);
            this.addRing(ratio);
        }

        this._canvas.onUpdate.add(() => {
            var dist = this._gap / this._canvas.camera.zoom;
            this.element.quaternion.copy(this._canvas.camera.quaternion);
            for (var i = 0; i < this._rings.length; ++i) {
                var ring = this._rings[i];
                ring.scale.setScalar(options.radius + ((i + 1) * dist));
            }
        });
    }

    private addRing(opacity: number) {

        if (!Rings3d._geometry) {

            var steps: number = 128;
            var points: THREE.Vector3[] = [];
            for (var i = 0; i <= steps; ++i) {
                var angle = (i / steps) * (Math.PI * 2);
                var x = Math.cos(angle);
                var z = Math.sin(angle);

                points.push(new THREE.Vector3(x, z, 0));
            }
            Rings3d._geometry = new THREE.BufferGeometry().setFromPoints(points);
        }

        const material = new THREE.LineBasicMaterial({ color: 0xFFFFFF, transparent: true, opacity: opacity });
        this.addMaterial(material);
        const ring = new THREE.Line(Rings3d._geometry, material);
        this._rings.push(ring);
        this.element.add(ring);
    }
}